// extracted by mini-css-extract-plugin
export default {"btnPrimary":"ButtonPrimaryIcon_btnPrimary__7SYMW"};